var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIsracard = function SvgIsracard(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 .5h24A3.5 3.5 0 0 1 31.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20V4l.005-.18A3.5 3.5 0 0 1 4 .5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    d: "M4 .5h24A3.5 3.5 0 0 1 31.5 4v16a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 20V4l.005-.18A3.5 3.5 0 0 1 4 .5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#isracard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE2D24",
    d: "M6.985 11.214a1.09 1.09 0 0 0 0 1.572l5.036 4.888a1.17 1.17 0 0 0 1.618 0l5.036-4.888a1.09 1.09 0 0 0 0-1.572l-5.036-4.888a1.17 1.17 0 0 0-1.618 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#352AFF",
    d: "M13.625 11.214a1.09 1.09 0 0 0 0 1.572l5.035 4.888a1.17 1.17 0 0 0 1.62 0l5.034-4.888a1.09 1.09 0 0 0 0-1.572L20.28 6.326a1.17 1.17 0 0 0-1.619 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "isracard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.65 6h19v12h-19z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIsracard);
export default ForwardRef;